import store from '../../../store'

const setFilterParams = (params) => {
  store.commit('SET_FILTER_PARAMS', params)
}

const resetFilterParams = () => {
  store.commit('RESET_FILTER_PARAMS')
}

export {
  setFilterParams,
  resetFilterParams
}



// WEBPACK FOOTER //
// ./src/scripts/modules/store/filters-setters.js